require('./bootstrap');

$(document).click(function (e) {
    if ($(e.target).closest('.nav').length || $(e.target).closest('.toggle-menu').length) return;
    $('.nav').removeClass('active');
    $('body').removeClass('opened');
    e.stopPropagation();
});

$('.toggle-menu').on('click', function () {
    $('body').addClass('opened');
    $('.nav').addClass('active');
});

document.addEventListener('DOMContentLoaded', function() {
    var modal = document.getElementById("lightboxModal");
    var modalImg = document.getElementById("img01");
    var captionText = document.getElementById("caption");

    document.querySelectorAll('.lightbox-image').forEach(function(img) {
        img.onclick = function() {
            modal.style.display = "block";
            modalImg.src = this.src;
            captionText.innerHTML = this.alt;
        }
    });

    var span = document.getElementsByClassName("modal")[0];
    span.onclick = function() {
        modal.style.display = "none";
    }
});